import { report_def, ReportStructure } from "./core/pdf/types";
import { Element, RefTableElement } from "./data-entry/types";


export interface PaymentMethod {
	//card
	cardType: string,
	cardName: string,
	cardNumber: string,
	cardExpiryMonth: number,
	cardExpiryYear: number,
	
	cardCVN: string,

	givenName1: string,
	familyName: string,

	companyName: string,

	careOf: string,
	line2: string,
	street: string,
	locality: string,
	state: string,
	postCode: string,
	country: string,

	token: string,
}

export interface account {
    id: string,
    owner: string,

    address: Address,
    addressPostal: Address,

    name: string,

	paymentMethod: PaymentMethod,

    whitelabel: {

    },
}


export interface account_form {
    id: string,
    account: string,
    def: string | form_def, // form definition
    workflow: string,

    data: any,
	generatedData?: any,

    title: string,
    
    copiedFrom: string, // id of source form
    entitiesReferenced: string[],

	refs?: {
		[k: string]: ref,
	},
	subForms?: {
		[k: string]: form_def,
	},
	reports?: {
		[k: string]: report_def,
	},
	
}

export interface InvoiceItem {
	desc: string,

	includedInSubscription?: boolean,

	qty: number,
	unitCost: number,
	tax: number,
	total: number,
}

export interface account_invoice {
	id: string,

	account: string,

	title: string,
	tax: number,
	subTotal: number,
	total: number,

	items: InvoiceItem[],

	created: string,
	updated: string,
	paid: string, // datetime paid successfully
	paid_log_id: string,
}


export interface account_resource {
    id: string, // unique id + doubles as blobid
    account: string,
    owner: string, // user
	deleted: number,
	version: number,

	title: string,
	ext: string,
	sizeBytes: number,
}


export interface account_invite {
    id: string, 
	
    account: string,
	accountName: string,
    
    token: string,
    email: string,
    name: string,
	invitedBy: string,
	invitedByName: string,

	existingUser?: boolean,

    resendCount: number,
    dateAccepted: string,
}


export interface HistoryItem {
	type: "chat" | "milestone",
}

export interface ChatMessage extends HistoryItem {
	from?: string,
	fromName?: string,

	message: string,
}

export interface Milestone extends HistoryItem {
	name: string,
}

export interface account_wf_history {
	id: string,
	account_wf: string,
	created: string,
	created_by: string,
	deleted: boolean,
	data: ChatMessage | Milestone,
}


export interface doc_ref {
    ext: string,
    type: string,
    title: string,
    blob: string,
	event?: string,
    sizeBytes: number,
    created: string, // datetime    
}

// export interface form_ref {
//     id: string,
// }
export type form_ref = string;

export interface account_wf {
    id: string,
    account: string,
    def: string,
    owner: string, // user

    title: string,
    
    deleted: boolean,

	updated: string,

	incompleteForm?: boolean,

    state: {
        current: string,
        phase: string,

		icon?: string,

		def?: WorkflowState,
    },

    history: any[],


    resources: {
        docs: doc_ref[],
        forms: form_ref[],
		invoices?: string[],
		urls: {
			url: string,
			title: string,
		}[],
    }
}

export interface form_def {
	id: string,
	title: string,
    data: Element,
	deleted: number,
	version: number,
	created: string,
	updated: string,
	lastSync: number, // version of last sync
	meta: any,

	refs?: {
		[k: string]: ref,
	},
	subForms?: {
		[k: string]: form_def,
	},
	reports?: {
		[k: string]: report_def,
	},
}

//--------------------------------------



export interface wf {
	id: string,
	title: string,
    data: WorkflowDef,
	deleted: number,
	version: number,
	created: string,
	updated: string,
	lastSync: number, // version of last sync
	meta: any,
}


//-------------------------------------





export interface RefTable {
	rows: any[],
	columns: any[],
}

export interface ref {
    id: string,
    title: string,
	data: RefTable,	
	version: number,
	created: string,
	updated: string,

}

export interface script {
    id: string,
    title: string,
	script: string,
	version: number,
	created: string,
	updated: string,
}

export interface Transition {
	actionTitle: string, // i.e. what is on the button text
	toState: string, // id of next state
	isDefault?: boolean,

	availableWithFormErrors?: boolean, // is this transition allowed even if the form has errors

	requestPayment?: boolean, // payment modal shown to get payment for any current invoice on this order

	role?: string, // if a specific role is required to perform this action

	hidden?: boolean,
}

export type FeatureType =
	"view-form" |
	"copy-form" |
	"set-acn" |
	"download-csv" |
	"asic-data" |
	"update-entity"
;

export interface Feature {
	feature: FeatureType,
	options?: any,
	adminOnly?: boolean,
}


export type WorkflowActionType = 
	"start-form" | 
	"change-state" | 
	"progress-workflow" |
	"data-access" |
	"integration" |
	"notification" |
	"generate-doc" |
	"raise-invoice"
;

export interface WorkflowAction {
	type: WorkflowActionType,
	options?: any,
}

export type WorkflowEventType =
	"enter-state" |
	"leave-state" |
	"form-save" |
	"integration-event"
;

export interface WorkflowEvent {
	type: WorkflowEventType,
	actions: WorkflowAction[],
}

export interface WorkflowState {

	id: string,

	title: string,
	phase: string,


	canEditForms?: boolean,
	canDeleteForms?: boolean,
	waitingForCompletion?: boolean,
	editWorkflow?: {
		allow: boolean,
		role?: string,
	},

	color?: string,

	transitions: Transition[],

	features: Feature[],

	events: WorkflowEvent[],

}

export interface WorkflowDef {

	states: WorkflowState[],


}





export type AddressType =
	"physical" |
	"postal" |
	"home" |
	"work" |
	"registered-office" |
	"meeting" |
	"ppob" | // principal place of business
	"delivery" |
	"pob" // place of birth
;
export function getAddressTypeName(type: AddressType) {
	const map = {
		"physical": "Physical",
		"postal": "Postal",
		"home": "Home",
		"work": "Work",
		"registered-office": "Registered Office",
		"meeting": "Meeting",
		"ppob": "Principal Place of Business",
		"delivery": "Delivery",
		"pob": "Place of Birth",
	} as any;

	return map[type];
}



export type EntityType = 
	"individual" |
	"joint" |
	"company" |
	"foreign-company" |
	"trust" |
	"smsf"
;

export const AllEntityTypes: EntityType[] = [
	"individual",
	"joint",
	"company",
	"foreign-company",
	"trust",
	"smsf"
]

export function getEntityTypeName(type: string) {
	const map = {
		"individual": "Individual",
		"joint": "Joint Holding",
		"company": "Australian Company",
		"foriegn-company": "Foreign Company",
		"trust": "Trust",
		"smsf": "SMSF",
	} as any;

	return map[type];
}

export const GroupLayoutOptions = [
	{ id: "vert", name: "Vertical" },
	{ id: "horiz", name: "Horizontal" },
];

export const ScriptLanguages = [
	{ id: "javascript", name: "Javascript" },
	{ id: "json", name: "JSON" },
];

export interface TrackedItem {
	effective: string,
	ceased: string,
}

export interface Address extends TrackedItem {
	type?: AddressType,
	careOf?: string,
	line2?: string,
	street?: string,
	locality: string,
	state?: string,
	postCode?: string,
	country?: string,
}

export interface Name extends TrackedItem {
	display: string,
    title: string,
    given1: string,
    given2: string,
    given3: string,
    family: string,
}


export type RelationshipType = 
    "officer" | 
    "shareholder" | 
    "trustee";

const RelationshipTypeName: {
    [k in RelationshipType]: string;
} = {
    "officer": "Officer",
    "shareholder": "Shareholder",
    "trustee": "Trustee"
};

export function getRelationshipTypeName(type: RelationshipType) {
	return RelationshipTypeName[type];
}

export interface Relationship {
	related: string, // id of related entity

	type: RelationshipType,
	
	effective: string,
	ceased?: string,
}


export interface EntityData {
	type: EntityType,

	relationships?: Relationship[],
}

export interface POB {
	locality: string,
	suburb: string,
	state?: string,
	postcode?: string,
	country?: string,
}

export interface Individual extends EntityData {
	names: Name[],
	addresses: Address[],
	addressesPostal: Address[],
	dob: string,
	pob: POB,
}

export interface JointHolding extends EntityData {
	names: Name[], // name to summarise the entire joint holding

	representatives: EntityData[],
}


export interface CompanyName extends TrackedItem {
	name: string,
}

export type CompanyOfficerType =
	"Director" |
	"Secretary" | 
	"Alternate"
;

export type PositionStatus = 
	"Appointed" | 
	"Resigned" |
	"Removed" |
	"Deceased"
;

export type MeetingStatus = 
	"Attendee" | 
	"Signatory" | 
	"Chairperson" |
	"Form Signatory" |
	"Apology" | 
	"Non Attendee"
;

export interface CompanyOfficer extends TrackedItem {
	type: CompanyOfficerType,
	entity: string, // id of entity for this party

	status: PositionStatus, // when choose any status other than appointed the cease date is mandatory
	meetingStatus: MeetingStatus,

	notes?: string,
}

export interface ShareHolder extends TrackedItem {

	entity: string,
	entityName?: string,

	beneficiallyHeld?: boolean,
	beneficialOwnerEntity?: string,

	shareCount: number,
	shareClass: number,

	// certificates
	// NOTE: only one cert per share holding
}

export type CompanyStatusType = 
	"Operating" |
	"Deregistered" | 
	"Pending Deregistration" |
	"Liquidation" |
	"Dormant"
;
export interface CompanyStatus extends TrackedItem {
	type: CompanyStatusType,
}

export type CompanyTypes = 
	"Small Proprietary" |
	"Large Proprietary" |
	"Public Company" |
	"Registrable Body" |
	"Foreign"
;

export type CompanyClass =
	"Limited by Shares" |
	"Limited by Guarantee" |
	"Limited by Shares and Guarantee" |
	"Unlimited" |
	"No Liability"
;

export type CompanySubClass = 
	"Non Profit Company" |
	"Home Unit Company" |
	"Superannuation Trustee Company" |
	"Listed" |
	"Unlisted" |
	"Unlisted Superannuation Trustee Company"
;

export interface CompanyType extends TrackedItem {
	type: CompanyTypes,
	class: CompanyClass,
	subClass: CompanySubClass,
}

export interface Company extends EntityData {
	names: CompanyName[],

	acn: string,
	corporateKey: string,

	registered: string,
	state: string,

	// foreign
	foreignCountry?: string,
	foreignRegistration?: string, // not sure why need this date?

	// dates
	incorporation: string,
	annualReview: string, // anniversary of the registration date
	constitutionIssued: string,
	constitutionUpdated: string,

	// status
	statuses: CompanyStatus[],

	// type
	companyTypes: CompanyType[],

	regOffs: Address[],
	ppobs: Address[],

	officers: CompanyOfficer[],
	shareHolders: ShareHolder[],
}

export interface SMSFTrustee extends TrackedItem {

	entity: string,
	entityName?: string,

}

export interface SMSFMember extends TrackedItem {

	entity: string,
	entityName?: string,

}

export interface SMSF extends EntityData {
	names: CompanyName[],
	
	established: string,

	applicableLaw: string,
	weightedVoting: boolean,

	trustees: SMSFTrustee[],
	members: SMSFMember[],


}

export interface Trust extends EntityData {
	trustType: string,

	names: CompanyName[],

	state: string,

	addresses: Address[],

	// dates
	established: string, // dt

	// misc
	deedType: string,

	settlor: {
		name: Name,
		address: Address,
	},
	settledSum: number,

	unitTrustType: string,

	trustees: Trustee[],
	appointors: Appointor[],
	beneficiaries: Beneficiary[],
	unitHolders: UnitHolder[],

	// succession plan??
}

export interface Trustee extends TrackedItem {
	entity: string, // id of entity
	notes?: string,
}
export interface Appointor extends TrackedItem {
	entity: string, // id of entity
	notes?: string,
}
export interface Beneficiary extends TrackedItem {
	entity: string, // id of entity
	relationship: string, // rel to the appointor
	notes?: string,
}
export interface UnitHolder extends TrackedItem {
	entity: string, // id of entity
	notes?: string,
}

export interface entity {
    id: string,
	account: string,

	data: EntityData,

	title: string, // display name that varies based on entity type
    
    deleted: boolean,
}

export interface entity_rel {
	id: string,
	account: string,
	entity: string,
	related: string,
	type: string,
}


export interface event {
    id: string,
    type: string,

	data: any,

	account_wf: string, // id of account_wf if one is related
    
	processing_lock: string,
    
	created: string, // timestamp

	started: string, // timestamp
    completed: string, // timestamp
    failed: string, // timestamp

	history?: EventHistoryItem[],
    
	deleted: boolean,
}
export interface EventHistoryItem {
	date: string,
	message: string,
}


// techsync
export interface job {
    id: string,

	num: string,

	created?: string,
	deleted?: string,
	
}
